import {
  Breadcrumbs as WtrBreadcrumbs,
  BreadcrumbLink,
} from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Breadcrumbs';

import { ContentResponse } from 'services/content/types';
import { EXTERNAL_ROUTES } from 'renderer/pages/route-map';
import { enrichBreadcrumbs } from 'renderer/components/Breadcrumbs/enrich-breadcrumbs';

import { normaliseBreadcrumbLink } from './normalise-breadcrumb-link';
import styles from './Breadcrumbs.module.scss';

const Breadcrumbs = ({
  authorableBreadcrumb,
  breadcrumbs = [],
}: Pick<ContentResponse, 'breadcrumbs' | 'authorableBreadcrumb'>) => {
  const normalisedBreadcrumbs = authorableBreadcrumb ? breadcrumbs.slice(0, -1) : breadcrumbs;
  const enrichedBreadcrumbs = enrichBreadcrumbs(normalisedBreadcrumbs);

  return (
    <>
      <WtrBreadcrumbs data-testid="breadcrumbs" className={styles.breadcrumbs}>
        <BreadcrumbLink href={EXTERNAL_ROUTES.homepage}>Home</BreadcrumbLink>
        {enrichedBreadcrumbs?.map(({ name, path }) => (
          <BreadcrumbLink href={normaliseBreadcrumbLink(path)} key={path} role="link">
            {name}
          </BreadcrumbLink>
        ))}
      </WtrBreadcrumbs>
    </>
  );
};

export default Breadcrumbs;
